export default "__VITE_ASSET__DTs_acB6__"